import React from 'react';
import './AddLanguageModal.css'; // We'll create this CSS file next

function AddLanguageModal({
  isOpen,
  onClose,
  newTranslationLanguage,
  setNewTranslationLanguage,
  handleTranslate,
  setIsLoading,
  setMessage,
}) {
  if (!isOpen) return null;

  const commonLanguages = [
    { code: 'de', name: 'German' },
    { code: 'ar', name: 'Arabic' },
    { code: 'hi', name: 'Hindi' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'ru', name: 'Russian' },
    { code: 'it', name: 'Italian' },
    { code: 'ta', name: 'Tamil' },
    { code: 'te', name: 'Telugu' },
  ];

  const handleTranslateClick = async () => {
    await handleTranslate();
    onClose(); // Close modal after translation attempt
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Add New Language Translation</h2>
        <div className="modal-body">
          <label htmlFor="new-language-select">Select Language:</label>
          <select
            id="new-language-select"
            value={newTranslationLanguage}
            onChange={(e) => setNewTranslationLanguage(e.target.value)}
          >
            <option value="">Select Language</option>
            {commonLanguages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.name}
              </option>
            ))}
          </select>
          <button onClick={handleTranslateClick} disabled={!newTranslationLanguage}>
            Add Language
          </button>
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="close-button">Close</button>
        </div>
      </div>
    </div>
  );
}

export default AddLanguageModal;
